module.exports = __webpack_public_path__ + "img/avtor.86f1adbd.jpg";